import * as React from 'react';
import { type FC } from 'react';

import { COUNTRIES, STATES } from '@admin/constants/geography';

import { SelectFormGroup, type SelectFormGroupProps } from './select_form_group';

export type StateSelectFormGroupProps = Omit<SelectFormGroupProps, 'children' | 'value' | 'onChange'> & {
  value?: string;
  onChange(value: string | undefined): void;
};

export const StateSelectFormGroup: FC<StateSelectFormGroupProps> = ({ value, onChange, ...props }) => (
  <SelectFormGroup {...props} value={value ?? ''} onChange={(event) => onChange(event.target.value || undefined)}>
    <option value="">- State -</option>
    {COUNTRIES.map((country, key) => (
      <optgroup label={country} key={key}>
        {STATES[country].map((state, key) => (
          <option value={state} key={key}>
            {state}
          </option>
        ))}
      </optgroup>
    ))}
  </SelectFormGroup>
);
